import { getEntityPageUrl } from '@/features/statisticsPage/utils';

export const ROUTE_PATH = getEntityPageUrl('campaigns');

export const DETAILS_ROUTE_PATH = `${ROUTE_PATH}/details`;

export const RESOURCE_NAME = 'campaignsStatisticsPage';
